import axios from 'axios';
import Qs from 'qs';
import { omit } from 'lodash';

export const baseApi = axios.create();

const getSortQuery = (sort: Record<string, string>) => {
  const array = Object.entries(sort)
    .filter(([, sorting]) => sorting !== 'undef')
    .map(([field, sorting]) => `${field},${sorting}`);

  return Qs.stringify(
    {
      sort: array,
    },
    { skipNulls: true, arrayFormat: 'repeat' }
  );
};

baseApi.interceptors.request.use((req) => {
  req.paramsSerializer = (params) => {
    const query = Qs.stringify(omit(params, 'sort'), { skipNulls: true });
    if (params.sort) {
      const sortQuery = getSortQuery(params.sort);
      if (!sortQuery) {
        return query;
      }
      return `${query}&${sortQuery}`;
    }

    return query;
  };
  return req;
});
